import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface CreateMfaSecretResponseModel {
	readonly mfaToken: string;
	readonly mfaUrl: string;
}

export const useCreateMfaSecret = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse<CreateMfaSecretResponseModel>> = () => {
		return http<CreateMfaSecretResponseModel>({
			method: "POST",
			url: "/mfa/create",
			body: undefined
		});
	};

	return useHTTPMutation({ mutationFn });
};
